module.exports = __webpack_public_path__ + "static/img/sbiz-bigdata.e481748.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/sbiz-bigdata.jpg
// module id = qSpT
// module chunks = 0